import { createContext, useContext } from "react";

import type { DialogActions } from "./Dialog.types";

const DialogActionsContext = createContext({} as DialogActions);

function useDialogActions<T extends DialogActions>() {
  return useContext(DialogActionsContext) as T;
}

export { DialogActionsContext, useDialogActions };
